import { render, staticRenderFns } from "./ProcessNarration.vue?vue&type=template&id=2b90f1ca&"
import script from "./ProcessNarration.vue?vue&type=script&lang=js&"
export * from "./ProcessNarration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports